import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TextField from '@material-ui/core/TextField';
import { AccordionDetails, AccordionSummary } from '@material-ui/core';

const styles = theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  fullParent: {
    width: '100%',
  },
  infoText: {
    color: 'black',
  },
});

export const SiteExpansionPanel = props =>
    <ExpansionPanel key={props.key}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={props.classes.heading}>{props.name}</Typography>
        </AccordionSummary>
        <AccordionDetails>
            <TextField
                className={props.classes.fullParent}
                disabled={true}
                id="phone"
                label="Email"
                value={props.email || 'Non défini'}
                margin="normal"
                InputProps={{
                    classes: {
                        root: props.classes.infoText,
                        input: props.classes.infoText,
                    },
                    disableUnderline: true,
                }}
            />
            <TextField
                className={props.classes.fullParent}
                disabled={true}
                id="phone"
                label="Téléphone"
                value={props.phone || 'non défini'}
                margin="normal"
                InputProps={{
                    classes: {
                        root: props.classes.infoText,
                        input: props.classes.infoText,
                    },
                    disableUnderline: true,
                }}
            />
        </AccordionDetails>
    </ExpansionPanel>;

SiteExpansionPanel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SiteExpansionPanel);



// WEBPACK FOOTER //
// ./src/components/Site/SiteExpansionPanel.jsx